/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/



const GuardedSignUpRoute = ({ children }) => {
    console.log('process.env.REACT_APP_REGISTER_MODE', process.env.REACT_APP_REGISTER_MODE)
    console.log('process.env.REACT_APP_REGISTER_MODE', process.env.REACT_APP_REGISTER_MODE === "true")

    return process.env.REACT_APP_REGISTER_MODE === "true" ? children : null;
}
export default GuardedSignUpRoute;